import { useState } from "react";
import * as S from "./PatientSelection.style"
import { useTranslation } from "react-i18next";
import PatientForm from "../patientForm";
import PatientFirm from "../patientFirm";
import ZaiaModalResponseContent from "../../../../../../../zaiaComponents/zaiaModalResponseContent";
import { MUTATION_INSERT_SIGN_INFORMED_CONSENT } from "../../../../../../../../graphql/mutations/SigninformedConsent";
import { useMutation } from "@apollo/client";
import useDoctorData from "../../../../../../../../hooks/useDoctorData";

function PatientSelection({
  patientData,
  setPatientData
}) {

  const { t, i18n: { language } }= useTranslation("global");
  const {doctorData} = useDoctorData();

  const [patientVerified, setPatientVerified] = useState(false);
  const [temporalPatientInfo, setTemporalPatientInfo] = useState(null);
  const [patientId, setPatientId] = useState("");

  const [patientAddedSuccess, setPatientAddedSuccess] = useState(null);

  const [insertSignInformedConsent, {loading: insertSignInformConsentLoading}] = useMutation(MUTATION_INSERT_SIGN_INFORMED_CONSENT);

  const handleSaveNewPatient = async (signature) => {
    try {
      const {data} = await insertSignInformedConsent({
        variables: {
          signInformedConsent: {
            name: temporalPatientInfo.name,
            documentNumber: temporalPatientInfo.document,
            documentType: temporalPatientInfo.typeDocument,
            phone: temporalPatientInfo.phone,
            doctorId: doctorData.id,
            signature: signature
          }
        }
      })
      setPatientAddedSuccess(true);
    } catch (error) {
      setPatientAddedSuccess(false);
    }
  }

  const asignPatient = () => {
    setPatientData(temporalPatientInfo);
  }

  if(patientAddedSuccess !== null) {
    return (
      <ZaiaModalResponseContent
        button1={() => patientAddedSuccess ? asignPatient() : setPatientAddedSuccess(null)}
        formSuccess={patientAddedSuccess}
        button1Text={patientAddedSuccess ? t("followUp.confirm") : t("globally.tryAgain")}
        title={patientAddedSuccess ? t("chatbotAI.imageReading.signUpSuccess") : t("chatbotAI.imageReading.signUpError")}
      />
    )
  }

  return (
    <S.PatientSelection>
      {
        !patientVerified ? (
          <PatientForm
            patientVerified={patientVerified}
            setPatientVerified={setPatientVerified}
            temporalPatientInfo={temporalPatientInfo}
            setTemporalPatientInfo={setTemporalPatientInfo}
            patientData={patientData}
            setPatientData={setPatientData}
            patientId={patientId}
            setPatientId={setPatientId}
          />
        ) : (
          <PatientFirm
            setPatientVerified={setPatientVerified}
            handleSaveNewPatient={handleSaveNewPatient}
          />
        )
      }
    </S.PatientSelection>
  );

}

export default PatientSelection;
